import { FC, useEffect } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { DueDateType } from "../../../http/dueDateTypes/types";
import Form from "../../ui/Form";
import FormField from "../../ui/FormField";
import FormFieldsContainer from "../../ui/FormFieldsContainer";
import Input from "../../ui/Input";

export interface DueDateTypeFormBody {
  name: string;
}

type DueDateTypeFormProps = {
  dueDateType?: DueDateType | null;
  onSubmit: (form: DueDateTypeFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const DueDateTypeForm: FC<DueDateTypeFormProps> = ({
  dueDateType,
  onSubmit,
  isDisabled,
  isLoading,
}: DueDateTypeFormProps) => {
  const i18n = useI18n();

  const defaultValues = { name: dueDateType?.name };

  return (
    <Form<DueDateTypeFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled}
      onSubmit={() => onSubmit}
      itemCreationInfo={dueDateType}
    >
      {({ register, reset, formState: { errors } }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [dueDateType]);

        return (
          <FormFieldsContainer>
            <FormField label={i18n.t.common.name} error={errors.name}>
              {({ labelId, isInvalid }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  disabled={isDisabled || isLoading}
                  {...register("name", {
                    required: true,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default DueDateTypeForm;
